export default __webpack_public_path__ + "static/media/button_4.c80f402b.png";